import { Clock, MarkerPin01, User01 as User } from "@untitledui/icons";
import { useAddressResolver, useAddressToggle } from "../../../hooks";
import type { TripCardProps } from "../../../types/cards.types";
import { formatTripPeriod, isTripEndLocationFinal } from "../../../utils";
import { AddressDisplay } from "../address-display";
import { BaseCard } from "../base-card";

export const TripCard = ({
	data,
	index = 0,
	isSelected = false,
	onClick,
	style,
}: TripCardProps) => {
	const { showStart, showFinal, toggleStart, toggleFinal } = useAddressToggle();
	const isEndLocationFinal = isTripEndLocationFinal(index, data.end);

	const {
		address: startAddress,
		isLoading: isLoadingStart,
		fetchIfMissing: fetchStartAddress,
	} = useAddressResolver({
		latitude: data.startLatitude,
		longitude: data.startLongitude,
		initialAddress: data.addressStarting ?? undefined,
	});

	const {
		address: finalAddress,
		isLoading: isLoadingFinal,
		fetchIfMissing: fetchFinalAddress,
	} = useAddressResolver({
		latitude: data.endLatitude,
		longitude: data.endLongitude,
		initialAddress: data.addressFinal ?? undefined,
	});

	return (
		<BaseCard
			isSelected={isSelected}
			onClick={onClick}
			style={style}
			variant="trip"
		>
			<div className="flex flex-col gap-2.5">
				<div>
					<p className="font-normal text-[12px]">
						{formatTripPeriod(data.start, data.end)}
					</p>
				</div>

				<div className="flex min-w-0 items-center gap-2">
					<div className="flex shrink-0 items-center self-stretch">
						<MarkerPin01 className="h-4 w-4 text-gray-500" size={16} />
					</div>
					<div className="flex min-w-0 flex-1 flex-col gap-2">
						<AddressDisplay
							address={startAddress}
							className="min-w-0 flex-1"
							isLoading={isLoadingStart}
							label="Início"
							onToggle={() => toggleStart(fetchStartAddress)}
							showMarkerIcon={false}
							showToggle={showStart}
							variant="toggle"
						/>

						<AddressDisplay
							address={finalAddress}
							className="min-w-0 flex-1"
							isLoading={isLoadingFinal}
							label={isEndLocationFinal ? "Fim" : "Atual"}
							onToggle={() => toggleFinal(fetchFinalAddress)}
							showMarkerIcon={false}
							showToggle={showFinal}
							variant="toggle"
						/>
					</div>
				</div>

				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2">
						<Clock size={16} />
						<span>{isEndLocationFinal ? "Terminou" : "Em andamento"}</span>
					</div>
					<div className="flex items-center gap-2">
						<User size={16} />
						<span className="text-[14px]">
							{data.driver?.name || "Sem motorista"}
						</span>
					</div>
				</div>
			</div>
		</BaseCard>
	);
};
